import React, { Component } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import "./testimonial.css";

export default class Testimonials extends Component {
  render() {
    return (
      <Carousel
        showArrows={true}
        showThumbs={false}
        infiniteLoop={true}
        showIndicators={false}
        showStatus={false}
        interval={5000}
        autoPlay
        autoFocus={true}
      >
        <div>
          <div className="myCarousel">
            <p>
              This is a great place to go take care of your teeth. The team was
              very professional examining and providing with solutions by
              priority. I had to do periodontal root cleaning and Dr Sandeep did
              a great job, I felt that I was in good hands. All the people here
              were very gentle and kind to me. They explained very well what was
              going on. Thanks to Dr Sandeep!
            </p>
            <h3>Shivin</h3>
            <h4>Mar 20,2020</h4>
          </div>
        </div>
        <div>
          <div className="myCarousel">
            <p>
              Dr. Jangra is highly professional. The performance for implants on
              me has been excellent. The Clinic is very well dessigned ensuring
              very high standards of Hygenic environmenet. The supporting Staff
              is excellent.
            </p>
            <h3>Ragini</h3>
            <h4>Jan 2,2021</h4>
          </div>
        </div>
        <div>
          <div className="myCarousel">
            <p>
              This is a great place to go take care of your teeth. The team was
              very professional examining and providing with solutions by
              priority. I had to do periodontal root cleaning and Dr Sandeep did
              a great job, I felt that I was in good hands. All the people here
              were very gentle and kind to me. They explained very well what was
              going on. Thanks 
            </p>
            <h3>Sakshi</h3>
            <h4>Feb 20,2021</h4>
          </div>
        </div>
        <div>
          <div className="myCarousel">
            <p>
              I had an amazing experience with Dr sandeep. He explained all the
              treatment and has lots of experience. The staff is very friendly
              and very welcoming. They make you feel right at home. Dr sandeep
              is very professional and very personable.
            </p>
            <h3>Mousumi</h3>
            <h4>Aug 17, 2017</h4>
          </div>
        </div>
        <div>
          <div className="myCarousel">
            <p>
              Amazing experience with all the staff from the front door to dr
              sandeep. He told me what I needed and what I didn’t very very
              happy with their service. Thanks to Dr Sandeep
            </p>
            <h3>Prof Sps Chauhan</h3>
            <h4>Dec 7,2019</h4>
          </div>
        </div>
        <div>
          <div className="myCarousel">
            <p>
              I went to Dr. Jangra for Root canal treatment. I am here to tell
              that my experience was great. The doctor is extremely well versed
              with the process and my treatment underwent with minimal pain. He
              didn't rush to complete my treatment and waited for the infection
              to subside. 
            </p>
            <h3>Utkarsh Srivastava</h3>
            <h4>May 24,2019</h4>
          </div>
        </div>
        <div>
          <div className="myCarousel">
            <p>
              Dr. Sandeep Jangra treated my teeth and performed an outstanding
              job. The work on root canal and the construction and fixing of the
              bridge was excellent. Dr.Jangra is an outstanding doctor and a
              highly professional in his field.
            </p>
            <h3>Premindra Sethee</h3>
            <h4>Dec 7,2020</h4>
          </div>
        </div>
        <div>
          <div className="myCarousel">
            <p>
              I’ve been coming to Dr Sandeep for several years,
              and they are absolutely fantastic. You must give them a try. You
              won’t be disappointed.
            </p>
            <h3>deepanshu</h3>
            <h4>Dec 12,2019</h4>
          </div>
        </div>
      </Carousel>
    );
  }
}
